"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
function PenTypesPanel({ className, type, onChange }) {
    const bridge = (0, bridge_1.useBridge)();
    const toolsService = (0, providers_1.useToolsService)();
    const penManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getPenToolManager();
    const penOptions = (0, hooks_1.usePenOptions)();
    const select2D = () => {
        sessionStorage.setItem('penType', '2d');
        penManager === null || penManager === void 0 ? void 0 : penManager.updatePenOptions({
            type: bridge_schema_1.ToolType.Pen2D,
            size: penOptions.size,
            color: penOptions.color,
            opacity: penOptions.opacity,
            optionType: 2,
        });
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.Pen2D,
            currentOptions: {
                type: bridge_schema_1.ToolType.Pen2D,
            },
        });
        onChange(bridge_schema_1.ToolType.Pen2D);
    };
    const select3D = () => {
        sessionStorage.setItem('penType', '3d');
        penManager === null || penManager === void 0 ? void 0 : penManager.updatePenOptions({
            type: bridge_schema_1.ToolType.Pen3D,
            size: penOptions.size,
            color: penOptions.color,
            opacity: penOptions.opacity,
            optionType: 2,
        });
        onChange(bridge_schema_1.ToolType.Pen3D);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'PenTypesPanel_Container', children: [(0, jsx_runtime_1.jsx)(ButtonContainer, { selected: type === bridge_schema_1.ToolType.Pen3D, "data-e2e": 'PenTypesPanel_ButtonContainer', children: (0, jsx_runtime_1.jsx)(Button, { selected: type === bridge_schema_1.ToolType.Pen3D, onClick: select3D, "data-e2e": 'PenTypesPanel_Button', children: (0, i18n_1.Localized)(i18n_1.Strings.tools.pen.d3) }) }), (0, jsx_runtime_1.jsx)(ButtonContainer, { selected: type === bridge_schema_1.ToolType.Pen2D, "data-e2e": 'PenTypesPanel_ButtonContainer', children: (0, jsx_runtime_1.jsx)(Button, { selected: type === bridge_schema_1.ToolType.Pen2D, onClick: select2D, "data-e2e": 'PenTypesPanel_Button', children: (0, i18n_1.Localized)(i18n_1.Strings.tools.pen.d2) }) })] }));
}
exports.default = PenTypesPanel;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const ButtonContainer = styled_components_1.default.div `
  position: absolute;
  bottom: 0;

  transform: translateY(${({ selected }) => (selected ? 0 : '-70px')});

  transition: transform 0.2s ease-in;
`;
const Button = (0, styled_components_1.default)(atoms_1.OptionsButton) `
  margin-left: 20px;
`;
